import React from 'react';
import {
  Form,
  Label,
  FormGroup,
} from 'reactstrap';
import PropTypes from 'prop-types';

import { FormField } from '../../../../../utils/FormFields';

function RelatedAccountsTab({
  account, changedAccount, showChanges,
}) {
  const editRelatedAccount = changedAccount.RelatedAccount[0];
  let compareRelatedAccount;
  account.RelatedAccount.map((a) => {
    if (parseInt(a.RelatedAccountId, 10) === parseInt(editRelatedAccount.RelatedAccountId, 10)) {
      compareRelatedAccount = a;
    }
    return {};
  });
  let color = 'black';
  if (showChanges) {
    if (compareRelatedAccount && editRelatedAccount.DeleteRelatedAccount) {
      color = 'red';
    } else if (compareRelatedAccount) {
      color = '#36a9e1';
    } else {
      color = 'green';
    }
  }
  return (
    <Form>
      <Label style={{
        fontWeight: 500,
        fontSize: '20px',
        display: 'block',
        color,
      }}
      >
        {showChanges
          ? (
            <React.Fragment>
              {editRelatedAccount.RelatedAccountId > 0
                ? (
                  <React.Fragment>
                    {editRelatedAccount.DeleteRelatedAccount ? 'Delete Related Account' : 'Edit Related Account'}
                  </React.Fragment>
                )
                : 'New Related Account'}
            </React.Fragment>
          )
          : 'Actual Account'}
      </Label>
      {showChanges
        ? (
          <FormGroup tag="fieldset">
            {!editRelatedAccount.DeleteRelatedAccount
              && (
                <FormToShow
                  relAccount={editRelatedAccount}
                  refRelAcc={compareRelatedAccount}
                />
              )}
          </FormGroup>
        )
        : (
          <FormGroup tag="fieldset">
            {compareRelatedAccount
              && (
                <FormToShow
                  relAccount={compareRelatedAccount}
                />
              )}
          </FormGroup>
        )}
    </Form>
  );
}

RelatedAccountsTab.propTypes = {
  changedAccount: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  showChanges: PropTypes.bool.isRequired,
};

export default RelatedAccountsTab;

const FormToShow = ({ relAccount, refRelAcc }) => (
  <React.Fragment>
    {relAccount.RelatedAccountId > 0 && (
      <FormField
        name="RelatedAccountId"
        value={relAccount.RelatedAccountId}
        label="Id"
      />
    )}
    <FormField
      name="RelatedAccountName"
      value={relAccount.RelatedAccountName}
      label="Name"
      changedColor={refRelAcc && relAccount.RelatedAccountName !== refRelAcc.RelatedAccountName}
    />
    <FormField
      name="BankAccountNumber"
      value={relAccount.RelatedAccountNumber}
      label="Number"
      changedColor={refRelAcc
        && parseInt(relAccount.RelatedAccountNumber, 10)
        !== parseInt(refRelAcc.RelatedAccountNumber, 10)}
    />
    <FormField
      name="CustodianEntityName"
      value={relAccount.CustodianEntityName}
      label="Custody"
      changedColor={refRelAcc
        && relAccount.CustodianEntityName !== refRelAcc.CustodianEntityName}
    />
  </React.Fragment>
);

FormToShow.propTypes = {
  relAccount: PropTypes.object.isRequired,
  refRelAcc: PropTypes.object,
};

FormToShow.defaultProps = {
  refRelAcc: undefined,
};
